import React from 'react';
import NotVerifiedSection from '../Components/NotVerfied';

const NotVerifiedPage = () => (
  <NotVerifiedSection />
);

export default NotVerifiedPage;
